<template>
	<div class="text-editor">
		<TinymceEditor
			ref="editor"
			:value="value"
			:apiKey="apiKey || $store.state.env.TINYMCE_API_KEY"
			:init="editorConfig"
			@input="textOnChange"
		/>
		<input
			v-show="false"
			id="imageUploader"
			type="file"
			accept="image/*"
			multiple
			@change="uploadFiles($event.target.files)"
		/>
		<input
			v-show="false"
			id="videoUploader"
			type="file"
			accept="video/*"
			multiple
			@change="uploadFiles($event.target.files, true)"
		/>
	</div>
</template>
<script>
	import TinymceEditor from '@tinymce/tinymce-vue';
	import { imageUpload, spinnerActive, spinnerInactive } from '@/util';

	export default {
		name: 'TextEditor',
		components: {
			TinymceEditor,
		},
		props: {
			value: {
				type: String,
				default: '',
			},
			width: {
				type: [Number, String],
				default: 'initial',
			},
			height: {
				type: Number,
				default: 360,
			},
			language: {
				type: String,
				default: null,
			},
			useBlockImage: {
				type: Boolean,
				default: true,
			},
			apiKey: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				editorConfig: {
					plugins: [
						'advlist autolink link image lists charmap print preview hr anchor pagebreak',
						'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
						'save table directionality template paste',
					],
					toolbar:
						'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | fontsizeselect link image',
					file_picker_types: 'file image media',
					image_description: true,
					image_dimensions: false,
					width: this.width,
					height: this.height,
					body_class: 'text-editor',
					fontsize_formats: '8px 10px 12px 14px 16px 18px 24px 36px',
					content_style: 'body { font-size: 14px } p { margin: 0 }',
					file_picker_callback(callback, value, meta) {
						if (meta.filetype === 'image') {
							document.getElementById('imageUploader').click();
						} else if (meta.filetype === 'media') {
							document.getElementById('videoUploader').click();
						}
					},
					language: this.language,
					extended_valid_elements:
						'video[autoplay|muted|loop|playsinline|class|style]',
				},
			};
		},
		methods: {
			textOnChange(e) {
				this.$emit('input', e);
			},
			uploadFiles(fileList, isVideoType) {
				spinnerActive();
				let files;

				if (typeof fileList === 'object') {
					files = Array.from(fileList);
				} else {
					files = fileList;
				}

				if (files.length === 0) {
					spinnerInactive();
					return false;
				}

				const image = files.shift();
				const ext = image.type.split('/').pop();
				const group = 'pouch';

				imageUpload(ext, group, image).then(res => {
					const src = `${this.$store.state.env.IMAGE_STORAGE_PATH}/${res.config.data.get('key')}`;

					this.$refs.editor.editor.editorManager.execCommand(
						'mceInsertContent',
						false,
						isVideoType
							? `<video autoplay muted loop playsinline style="object-fit:cover;width:100%;height:auto;">\n<source src="${src}"/></video>\n`
							: this.useBlockImage
								? `<img src="${src}" style="width:100%;display:block" alt="" />`
								: `<img src="${src}" alt="" />`
					);

					this.uploadFiles(files, isVideoType);
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	DIV.text-editor {
		display: inline-block;
		margin: auto;
	}
</style>
<style scss>
	.tox-dialog__disable-scroll {
		overflow: unset !important;
	}
</style>
